import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, shareReplay, Subject } from 'rxjs';
import { constants } from 'src/app/config/constant';
import { environment } from 'src/environments/environment';
import { ModuleService } from './components/ModuleService';
import { LogService } from './log.service';
import { MockSignalRService } from './mock.signalr.service';
import { db } from './db.service';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {

  private connectionURL: any;
  private components = new Subject<any>();
  private response = new Subject<any>();
  private isConnected = new BehaviorSubject<boolean>(false);

  public proxy: any;
  public _components: any;
  public busy: boolean = false;
  public connected: boolean = false;

  constructor(private router: Router, private logger: LogService, private config: constants, public mock: MockSignalRService) {
    this.connectionURL = config.SIGNALR_ENDPOINT;
    logger.log('SignalR constructor')
    this.connect()
  }

  getConnected = this.isConnected.asObservable().pipe(shareReplay());
  getComponents = this.components.asObservable();
  getResponse = this.response.asObservable();

  private connState: string[] = [
    'Connecting',
    'Connected',
    'Reconnecting',
    'Disconnecting',
    'Disconnected'
  ];

  private currConnState: number = 4;

  setVal(value: any) {
    this.components.next(value);
  }

  setResp(value: any) {
    this.response.next(value);
  }
  setConnection(value: boolean) {
    this.connected = value
    this.isConnected.next(value);
  }

  public connect() {
    return new Promise((resolve, reject) => {
      if (!this.config.KIOSK_ENABLED) {
        this.log('AppLog_Info', { message: 'Kiosk features are disabled.' })
        this.setConnection(true)
        resolve(this)
      }
      if (this.busy) {
        setTimeout((): any => {
          this.log('AppLog_Info', { message: 'trying to connect' })
          this.connect().then(() => {
            resolve(this)
          }).catch((e) => { reject(e) })
        }, 250);
      } else if (!this.connected) {
        this.log('AppLog_Info', { message: 'call connect' })
        this._connect().then(() => {
          resolve(this)
        }).catch((e) => { reject(e) })
      } else {
        resolve(this)
      }
    })
  }

  public _connect() {
    this.busy = true
    return new Promise((resolve, reject) => {
      // var con = $.hubConnection(this.connectionURL);
      let con = (<any>(environment.production ? $ : this.mock)).hubConnection(this.connectionURL) as any
      this.proxy = con.createHubProxy("DeviceManagerHub");

      // this.proxy.on('OnReconnected', (latestMsg: any) => this.onMessageReceived(latestMsg));
      //Bill Acceptor
      // this.proxy.on('onBillAcceptorConnected_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillAcceptorConnectedError_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onFirstBillAcceptorAccept_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillAcceptorAccepted_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillAcceptorEscrow_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillAcceptorReject_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillAcceptorReturn_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillAcceptorCassetteRemoved_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillAcceptorCassettePresent_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillAcceptorDisconnected_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillAcceptorDisconnectedError_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));

      //Bill Dispenser
      // this.proxy.on('onBillDispenserConnected_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillDispenserConnectedError_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillDispenserResetComplete_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillDispResponse', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillDispenserQueryStatus_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillDispenserDisconnected_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillDispenserLockUnlock_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onBillDispenserDispenseAction_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));

      //Mag Stripe Reader
      // this.proxy.on('onMagstripeReaderConnected_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onMagstripeReaderConnectedError_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onMagstripeReaderDisconnected_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onMagstripeReaderDisconnectedError_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      // this.proxy.on('onMagstripeReaderCardDataReceived_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));

      //PinPad
      this.proxy.on('onPinPadKeyRelease_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      this.proxy.on('onPinPadConnected_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      this.proxy.on('onPinPadConnectedError_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      this.proxy.on('onPinPadDisconnected_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));
      this.proxy.on('onPinPadDisconnectedError_Event', (latestMsg: any) => this.onMessageReceived(latestMsg));


      con.stateChanged((t: any, u: any) => {
        this.currConnState = t.newState;
        let a = this.connState[t.newState]
        this.log('AppLog_Info', { message: 'DeviceManager state changed from: ' + this.connState[t.oldState] + ' to ' + a + '' });
      });

      // If a disconnect occurs, then reconnect
      con.disconnected(() => {
        this.busy = false
        this.setConnection(false)
        setTimeout(() => {
          con.start().done(() => {
            // Connection re-established
          });
        }, 50);
      });

      con.start().done(() => {
      }).catch((err: any) => {
        this.busy = false
        this.log('AppLog_Error', { message: 'Connection Error', metadata: { error: err } })
        reject(err)
      });

      this.checkStatus()
    });
  }

  checkStatus() {
    const state = this.getServiceStatus();
    if (state === 1) {
      this.continueInit();
    } else {
      setTimeout(() => {
        this.checkStatus();
      }, 1000);
    }
  }

  getServiceStatus() {
    return this.currConnState;
  }

  continueInit() {
    this.log('AppLog_Info', { message: "Connected" });
    this.setConnection(true);
    this.busy = false
    return Promise.resolve(this)
  }

  public disconnect() {
    //Bill Acceptor
    // this.proxy.off('onBillAcceptorConnected_Event');
    // this.proxy.off('onBillAcceptorConnectedError_Event');
    // this.proxy.off('onFirstBillAcceptorAccept_Event');
    // this.proxy.off('onBillAcceptorAccepted_Event');
    // this.proxy.off('onBillAcceptorEscrow_Event');
    // this.proxy.off('onBillAcceptorReject_Event');
    // this.proxy.off('onBillAcceptorReturn_Event');
    // this.proxy.off('onBillAcceptorCassetteRemoved_Event');
    // this.proxy.off('onBillAcceptorCassettePresent_Event');
    // this.proxy.off('onBillAcceptorDisconnected_Event');
    // this.proxy.off('onBillAcceptorDisconnectedError_Event');

    //Bill Dispenser
    // this.proxy.off('onBillDispenserConnected_Event');
    // this.proxy.off('onBillDispenserConnectedError_Event');
    // this.proxy.off('onBillDispenserResetComplete_Event');
    // this.proxy.off('onBillDispResponse');
    // this.proxy.off('onBillDispenserQueryStatus_Event');
    // this.proxy.off('onBillDispenserDisconnected_Event');
    // this.proxy.off('onBillDispenserLockUnlock_Event');
    // this.proxy.off('onBillDispenserDispenseAction_Event');

    //Mag Stripe Reader
    // this.proxy.off('onMagstripeReaderConnected_Event');
    // this.proxy.off('onMagstripeReaderConnectedError_Event');
    // this.proxy.off('onMagstripeReaderDisconnected_Event');
    // this.proxy.off('onMagstripeReaderDisconnectedError_Event');
    // this.proxy.off('onMagstripeReaderCardDataReceived_Event');

    //PinPad
    this.proxy.off('onPinPadKeyRelease_Event');
    this.proxy.off('onPinPadConnected_Event');
    this.proxy.off('onPinPadConnectedError_Event');
    this.proxy.off('onPinPadDisconnected_Event');
    this.proxy.off('onPinPadDisconnectedError_Event');
  }

  private onMessageReceived(latestMsg: any) {
    this.setResp(latestMsg);
  }

  async setComponents() {
    this._components = await this.getAllComponents().catch(error => [])
  }

  public getComponent(component: string | ModuleService): Promise<{
    CompIdx: number,
    DeviceManagerInterface: number
  } | null> {
    let component_str: any = component;
    if (component instanceof ModuleService) {
      component_str = component.getModuleId()
      return new Promise(async (resolve, reject) => {
        // if (typeof this._components == "undefined") {
        //   this._components = await this.getAllComponents().catch((error) => { })
        // }
        let c = this.findComponent(this._components, component_str)
        if (c) {
          component.setHub(this.proxy)
          component.setData(c.CompIdx, c.DeviceManagerInterface)
          component.attachListeners()
          component.connect().then(() => {
            resolve(c)
          }).catch((e) => {
            this.log('AppLog_Error', {
              message: 'Failed to connect ' + component_str
            })
            reject('Failed to connect ' + component_str)
          })
        } else {
          this.log('AppLog_Error', {
            message: component_str + ' Module unavailable',
          })
          component.setUnavailable();
          reject(component_str + ' Module unavailable')
        }
      })
    }
    else {
      return new Promise(async (resolve, reject) => {
        if (typeof this._components == "undefined") {
          this._components = await this.getAllComponents().catch((error) => { reject(error) })
        }
        resolve(this.findComponent(this._components, component_str))
      })
    }
  }

  public findComponent(list: any, component: string) {
    return (list || []).find((c: any) => {
      return c.ComponentTypeName === component || !this.config.KIOSK_ENABLED
    })
  }

  public getAllComponents() {
    return new Promise((resolve, reject) => {
      if (!this.config.KIOSK_ENABLED) {
        resolve([{ CompIdx: 0, DeviceManagerInterface: 0 }])
      }
      if (this.proxy) {
        this.log('AppLog_Info', {
          message: 'getAllComponents called'
        })
        this.proxy.invoke('getAllComponents').then((components: any) => {
          this.log('AppLog_Info', {
            message: 'getAllComponents completed', metadata: { components }
          })
          resolve(components);
        }).catch((error: any) => {
          this.log('AppLog_Error', {
            message: 'getAllComponents failed', metadata: { error }
          })
          reject(error)
        })
      } else {
        this.log('AppLog_Error', {
          message: 'Proxy unavailable'
        })
        reject('Proxy unavailable')
      }
    })
  }

  public connectToComponent2(component: string) {
    this.proxy.invoke('getAllComponents').then((comps: any) => {
      if (comps.length > 0) {
        comps.forEach((c: any) => {
          if (c.ComponentTypeName === component && c.IsActive) {
            this.setVal(c);
          }
        });
      }
    });
  }

  log(type: 'AppLog_Info' | 'AppLog_Warning' | 'AppLog_Error', data: { message: string, metadata?: any }) {
    let timestamp = (new Date).toISOString()
    console.log(type, data)
    return new Promise((resolve, reject) => {
      try {
        db.signalRLogs.add({
          type,
          message: data.message,
          metadata: data.metadata,
          date_created: timestamp,
        })
      } catch (error) {
        db.signalRLogs.add({
          type: 'AppLog_Error',
          message: (error as any).toString(),
          date_created: timestamp,
        })
      }
      setTimeout(() => {
        this.proxy && this.proxy.invoke(type, JSON.stringify({ ...data, timestamp })).then(resolve).catch(reject)
      }, 0)
    });
  }
}
